import React, { useState, useEffect } from 'react';
import styles from '../../assets/css/components/Footer.module.css';
import { Stack, Typography } from '@mui/material';
import ScheduleIcon from '@mui/icons-material/Schedule';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import { ILobbyTournamentState } from '../../Core/State/ILobbyTournamentState';
import { ILobbyState } from '../../Core/State/ILobbyState';
import iconPokerTable from '/images/lobby/icon-poker-table.svg';
import { t } from '../../i18n';

interface DesktopFooterProps {
  lobbyState: ILobbyState;
  lobbyTournamentState: ILobbyTournamentState;
  userConnectedCount: number;
}

const DesktopFooter: React.FC<DesktopFooterProps> = ({ lobbyState, lobbyTournamentState, userConnectedCount }) => {
  const [hours, setHours] = useState<string>('');
  const [minutes, setMinutes] = useState<string>('');
  const [seconds, setSeconds] = useState<string>('');

  useEffect(() => {
    const updateTime = () => {
      const now = new Date();
      const hoursString = now.getHours().toString().padStart(2, '0');
      const minutesString = now.getMinutes().toString().padStart(2, '0');
      const secondsString = now.getSeconds().toString().padStart(2, '0');
      setHours(hoursString);
      setMinutes(minutesString);
      setSeconds(secondsString);
    };

    // Update immediately
    updateTime();

    // Update every second
    const interval = setInterval(updateTime, 1000);

    // Cleanup interval on unmount
    return () => clearInterval(interval);
  }, []);

  const tableCount = lobbyState?.rooms?.length || 0;
  const tournamentCount = lobbyTournamentState?.tournaments?.length || 0;
  const formattedNumber = new Intl.NumberFormat().format(userConnectedCount) || 0;

  return (
    <footer className={styles.footer}>
      <Stack direction="row" justifyContent="space-between" alignItems="center" style={{ width: '100%' }}>
        <Stack direction="row" justifyContent="center" alignItems="center" gap={0.5} style={{ backgroundColor: '#2a2b32', borderRadius: '4px', padding: '0 0.25rem' }}>
          <ScheduleIcon sx={{ fontSize: '14px', opacity: 0.7 }} />
          <Typography color="text.light" style={{ fontSize: '14px', fontWeight: 500, opacity: 0.7 }}>
            <code>{hours}</code>:<code>{minutes}</code>:<code>{seconds}</code>
          </Typography>
        </Stack>
        <Stack direction="row" alignItems="center" gap={0.5} style={{ backgroundColor: '#2a2b32', borderRadius: '4px', padding: '0 0.25rem', marginLeft: '0.5rem' }}>
          <Typography color="#3de361" style={{ fontSize: '14px', fontWeight: 500, letterSpacing: '0.5px' }}>
            {formattedNumber}
          </Typography>
          <span className={styles.dot}></span>
          <Typography style={{ color: '#3de361', fontSize: '12px', fontWeight: 500, lineHeight: '21px' }}>{t('DesktopFooter:playersOn')}</Typography>
        </Stack>
        <Typography color="text.light" sx={{ fontSize: '12px', fontWeight: 500, mx: 'auto', opacity: 0.7 }}>{t('DesktopFooter:clientVersion')} <code style={{ fontWeight: 600 }}>v{import.meta.env.VITE_APP_VERSION}</code></Typography>
        <Stack direction="row" alignItems="center" gap={0.5} style={{ backgroundColor: '#2a2b32', borderRadius: '4px', padding: '0 0.25rem' }}>
          <img src={iconPokerTable} alt="Poker Table icon" style={{ height: '11px', opacity: 0.7 }} />
          <Typography color="text.light" style={{ fontSize: '14px', fontWeight: 500, opacity: 0.7 }}>
            {t('DesktopFooter:tables', { count: tableCount })}
          </Typography>
        </Stack>
        <Stack direction="row" alignItems="center" gap={0.5} style={{ backgroundColor: '#2a2b32', borderRadius: '4px', padding: '0 0.25rem', marginLeft: '0.5rem' }}>
          <EmojiEventsIcon sx={{ fontSize: '14px', opacity: 0.7 }} />
          <Typography color="text.light" style={{ fontSize: '14px', fontWeight: 500, opacity: 0.7 }}>
            {t('DesktopFooter:tournaments', { count: tournamentCount })}
          </Typography>
        </Stack>
      </Stack>
    </footer>
  );
};

export default DesktopFooter;
